import { render, staticRenderFns } from "./template-project-activities.vue?vue&type=template&id=6a2eb8f7"
import script from "./template-project-activities.vue?vue&type=script&lang=js"
export * from "./template-project-activities.vue?vue&type=script&lang=js"
import style0 from "./template-project-activities.vue?vue&type=style&index=0&id=6a2eb8f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports